import { FormattedMessage } from 'react-intl';

import { Link } from 'react-router-dom';

import { AnimatedNumber } from 'mastodon/components/animated_number';
import { useIdentity } from 'mastodon/identity_context';
import type { Status } from 'mastodon/models/status';

export const StatusStatsBar: React.FC<{
  status: Status;
  onNavigate?: () => void;
}> = ({ status, onNavigate }) => {
  const { signedIn } = useIdentity();

  const isPrivate = ['private', 'direct'].includes(
    status.get('visibility') as string,
  );
  const acct = status.getIn(['account', 'acct']) as string;
  const id = status.get('id') as string;
  const reblogsCount = status.get('reblogs_count') as number;
  const quotesCount = status.get('quotes_count') as number;
  const favouritesCount = status.get('favourites_count') as number;

  const reblogLink = !isPrivate && (
    <Link
      to={`/@${acct}/${id}/reblogs`}
      className='detailed-status__link'
      onClick={onNavigate}
    >
      <FormattedMessage
        id='status.reblogs_count'
        defaultMessage='{count, plural, one {{counter} repost} other {{counter} reposts}}'
        values={{
          count: reblogsCount,
          counter: (
            <span className='detailed-status__reblogs'>
              <AnimatedNumber value={reblogsCount} />
            </span>
          ),
        }}
      />
    </Link>
  );

  const quotesContent = (
    <FormattedMessage
      id='status.quotes_count'
      defaultMessage='{count, plural, one {{counter} quote} other {{counter} quotes}}'
      values={{
        count: quotesCount,
        counter: (
          <span className='detailed-status__quotes'>
            <AnimatedNumber value={quotesCount} />
          </span>
        ),
      }}
    />
  );

  const quotesLink = isPrivate ? null : signedIn ? (
    <Link
      to={`/@${acct}/${id}/quotes`}
      className='detailed-status__link'
      onClick={onNavigate}
    >
      {quotesContent}
    </Link>
  ) : (
    <span className='detailed-status__link'>{quotesContent}</span>
  );

  const favouriteLink = (
    <Link
      to={`/@${acct}/${id}/favourites`}
      className='detailed-status__link'
      onClick={onNavigate}
    >
      <FormattedMessage
        id='status.favourites_count'
        defaultMessage='{count, plural, one {{counter} like} other {{counter} likes}}'
        values={{
          count: favouritesCount,
          counter: (
            <span className='detailed-status__favorites'>
              <AnimatedNumber value={favouritesCount} />
            </span>
          ),
        }}
      />
    </Link>
  );

  return (
    <div className='detailed-status__meta__line'>
      {reblogLink}
      {reblogLink && <>·</>}
      {quotesLink}
      {quotesLink && <>·</>}
      {favouriteLink}
    </div>
  );
};
